import React, { useState } from "react";
import "./fileupload.css";
import UploadIcon from "../../Images/Upload.png";
import { CloudUpload, ChevronLeft } from "lucide-react";
import { BASE_URL } from "../apiConfig";
import { useParams, useNavigate, useLocation } from "react-router-dom";

const ACCEPTED_EXTENSIONS = [".xlsx", ".csv"];

const FileUpload = () => {
  const location = useLocation();
  const [fileName, setFileName] = useState("");
  const [file, setFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [isDragging, setIsDragging] = useState(false);
  //   const { projectId } = useParams();
  const inputID = location.state?.inputID || location.state?.inputId;
  const clientID = location.state?.clientID;
  const roleId = location.state?.roleId;
  const {projectId}=useParams();
  const navigate = useNavigate();

  const isAcceptedFile = (selectedFile) => {
    if (!selectedFile?.name) return false;
    const lowerName = selectedFile.name.toLowerCase();
    return ACCEPTED_EXTENSIONS.some((ext) => lowerName.endsWith(ext));
  };

  const setSelectedFile = (selectedFile) => {
    if (!selectedFile) return;

    if (!isAcceptedFile(selectedFile)) {
      setError("Unsupported format. Please upload an xlsx or csv file.");
      return;
    }

    setFileName(selectedFile.name);
    setFile(selectedFile);
    setError("");
    setSuccess("");
  };

  const handleFileUpload = (event) => {
    const selectedFile = event.target.files?.[0];
    setSelectedFile(selectedFile);
    // Allow selecting the same file again after a failed attempt
    event.target.value = "";
  };

  const handleBrowseClick = () => {
    document.querySelector(".upload-input").click();
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (!isDragging) setIsDragging(true);
  };

  const handleDragLeave = (event) => {
    event.preventDefault();
    event.stopPropagation();
    // Only clear when leaving the dropzone itself, not child elements
    if (!event.currentTarget.contains(event.relatedTarget)) {
      setIsDragging(false);
    }
  };

  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsDragging(false);

    const droppedFile = event.dataTransfer?.files?.[0];
    setSelectedFile(droppedFile);
  };

  const handleSubmit = async (e) => {
    // Prevent the default form submission
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    // Check if file exists and display error if not
    if (!file) {
      setError("No file selected");
      console.log("No file selected error triggered");
      return;
    }

    setIsLoading(true);
    setError("");
    setSuccess("");

    try {
      const token = localStorage.getItem("accessToken");

      // Create FormData for file upload
      const formData = new FormData();
      formData.append("input_sheet", file);
      formData.append("project_id", projectId);

      console.log(
        "Uploading file to:",
        `${BASE_URL}/project/upload_input_data`
      );

      const response = await fetch(`${BASE_URL}/project/upload_input_data`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          // Don't set Content-Type here - the browser will set it with proper boundary for FormData
        },
        body: formData,
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || "Failed to upload file");
      }

      const data = await response.json();

      setSuccess("File uploaded successfully!");
      console.log("Upload successful:", data);

      navigate(`/architect/${data.latest_input}/summary`,{
        state:{
          projectId,
          inputID: data.latest_input,
          clientID,
          roleId,
        }
      });

      // Reset file state if needed
      // setFile(null);
      // setFileName('');
    } catch (err) {
      setError(err.message || "An error occurred during upload");
      console.error("Upload error:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleBack = () => {
    console.log(`input id ${inputID}`);
    // navigate(`/architect/${inputID}/summary`,{
    //     state:{projectId}
    // });
    navigate(-1); // Navigates to the previous page
  }

  return (
    <div className="upload-container">
      <button
        type="button"
        className="back-button"
        onClick={handleBack} // Navigates to the previous page
      >
        <span className="back-button-icon"></span> <ChevronLeft />
      </button>
      <h2 className="upload-title">Input Sheet Upload</h2>
      <div
        className={`upload-dropzone${isDragging ? " upload-dropzone-active" : ""}`}
        onDragEnter={handleDragOver}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
      >
        <img src={UploadIcon} alt="Upload Icon" className="upload-icon" />
        <p className="upload-text">
          Drag & drop files or{" "}
          <span className="upload-browse" onClick={handleBrowseClick}>
            Browse
          </span>
        </p>
        {fileName && <p className="upload-file-name">{fileName}</p>}
        <p className="upload-supported">Supported format: xlsx</p>
        <input
          type="file"
          accept=".xlsx,.csv"
          onChange={handleFileUpload}
          className="upload-input"
          style={{ display: "none" }}
        />

        {error && (
          <div className="upload-error" style={{ color: "red", marginTop: "10px", textAlign: "left" }}>
            {error.split("##").map((msg, i) => (
              <p key={i} style={{ margin: "2px 0" }}>{msg.trim()}</p>
            ))}
          </div>
        )}
        {success && (
          <p
            className="upload-success"
            style={{ color: "green", marginTop: "10px" }}
          >
            {success}
          </p>
        )}

        <button type="button" className="upload-button" onClick={handleSubmit}>
          <CloudUpload className="upload-button-icon" />
          {isLoading ? "Uploading..." : "Upload File"}
        </button>
      </div>
    </div>
  );
};

export default FileUpload;
